import {lazy} from 'react';
import {createBrowserRouter, createRoutesFromElements, Route} from "react-router";
import Error from "@/components/error/error.tsx";
import ShopRoutes from "./shop/routes.tsx";
import IdentityAccessManagmentRoutes from "./identity-access-management/authentication/routes.tsx";
import SettingsRoutes from "./workplace/features/settings/routes.tsx";
import StoriesRoutes from "./workplace/features/stories/routes.tsx";
import PartnerRoutes from "@/app/identity-access-management/partner/routes.tsx";

const Home = lazy(() => import('./workplace/features/home/home.tsx'));
const NotificationCenter = lazy(() => import('./workplace/features/notification-center/notification-center.tsx'));
const Company = lazy(() => import('./workplace/features/company/company.tsx'));
const Settings = lazy(() => import('./workplace/features/settings/features/settings/settings.tsx'));
const NewsletterConfirmedPage = lazy(() => import('./workplace/features/newsletter/features/newsletter-confirmed/newsletter-confirmed.tsx'));
const Search = lazy(() => import("./workplace/features/search/search.tsx"));
const Contact = lazy(() => import("@/app/workplace/features/contact/contact.tsx"));
const Impressum = lazy(() => import("@/app/workplace/features/Impressum/impressum.tsx"));
const FrequentlyAskedQuestions = lazy(
    () => import("@/app/workplace/features/frequently-asked-questions/frequently-asked-questions.tsx")
);
const TermsAndConditions = lazy(
    () => import("@/app/workplace/features/terms-and-conditions/terms-and-conditions.tsx")
);

const APP_ROUTER = createBrowserRouter(
    createRoutesFromElements([
        <Route path="/" element={<Home />} errorElement={<Error/>}/>,
        <Route path="/home" element={<Home />} errorElement={<Error/>}/>,
        <Route path="/workplace/notification-center" element={<NotificationCenter />} errorElement={<Error/>}/>,
        <Route path="/workplace/search" element={<Search />} errorElement={<Error/>}/>,
        <Route path="/company" element={<Company />} errorElement={<Error/>}/>,
        <Route path="/settings" element={<Settings />} errorElement={<Error/>}/>,
        <Route path="/contact" element={<Contact />} errorElement={<Error/>}/>,
        <Route path="/newsletter/confirmed" element={<NewsletterConfirmedPage />} errorElement={<Error/>}/>,
        <Route path="/impressum" element={<Impressum />} errorElement={<Error/>}/>,
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} errorElement={<Error/>}/>,
        <Route path="/faq" element={<FrequentlyAskedQuestions />} errorElement={<Error/>}/>,
        <Route path="*" element={<Error />}/>,
        IdentityAccessManagmentRoutes,
        PartnerRoutes,
        ShopRoutes,
        StoriesRoutes,
        SettingsRoutes
    ])
);
export default APP_ROUTER;
